export enum KeyConstants {
  ENTER = 'Enter',
  SPACE = 'Space',
  LEFT_NAV = 'ArrowLeft',
  RIGHT_NAV = 'ArrowRight',
}
